import React from 'react';
import InfoIcon from '../../assets/images/icons/info.svg';

interface CriteriaExplanationContainerProps {
	title: string | React.ReactElement;
	content: string | React.ReactElement;
}

const CriteriaExplanationContainer = ({ title, content }: CriteriaExplanationContainerProps) => {
	return (
		<div className="code-info">
			<div className="code-info-header">
				<img src={InfoIcon} alt="" aria-hidden="true" />
				<p role="heading" aria-level={2}>
					{title}
				</p>
			</div>
			<div className="code-info-template">{content}</div>
		</div>
	);
};

export default CriteriaExplanationContainer;
